import type { Bilingual } from './LanguageContext';

/** Shared UI copy (everything not tied to a specific mission/project). */
export const copy = {
  heroBadge: {
    en: 'The 1st Arabic robotics & electronics simulator',
    ar: 'أول محاكي إلكترونيات وروبوتيكس عربي',
  },
  headline1: { en: 'One Sandbox.', ar: 'ساندبوكس واحد.' },
  headline2: { en: 'Three Missions.', ar: 'ثلاث مهمات.' },
  headline3: { en: 'Infinite Ideas.', ar: 'أفكار بلا حدود.' },
  subheadline: {
    en: 'Learn robotics step by step, compete in smart robot challenges, or turn your idea into a real hardware prototype.',
    ar: 'تعلّم الروبوتات خطوة بخطوة، نافس في تحديات الروبوتات الذكية، أو حوّل فكرتك إلى نموذج أولي حقيقي.',
  },
  chooseMission: { en: 'Choose Your Mission', ar: 'اختر مهمتك' },
  startBuilding: { en: 'Start Building', ar: 'ابدأ البناء' },
  openSandbox: { en: 'Open the Sandbox', ar: 'افتح الساندبوكس' },
  navGallery: { en: 'Gallery', ar: 'المعرض' },
  navPricing: { en: 'Pricing', ar: 'الأسعار' },
  missionsKicker: { en: 'Pick your path', ar: 'اختر مسارك' },
  missionsTitle: { en: 'Three ways into the lab', ar: 'ثلاث بوابات إلى المختبر' },
  featuresKicker: { en: 'Everything in your toolkit', ar: 'كل ما تحتاجه في عدّتك' },
  projectsKicker: { en: 'From the community', ar: 'من المجتمع' },
  projectsTitle: { en: 'Featured Projects', ar: 'مشاريع مميزة' },
  viewAllProjects: { en: 'View all projects', ar: 'عرض كل المشاريع' },
  botMessage: { en: 'Hi! What do you want to do today?', ar: 'مرحباً! ماذا تريد أن تفعل اليوم؟' },
  pricingTitle: { en: 'Free while in open beta', ar: 'مجاني خلال النسخة التجريبية المفتوحة' },
  pricingText: {
    en: 'Full access to Learn, Compete, and Prototype — no credit card required. Team and school plans are coming soon.',
    ar: 'وصول كامل إلى مسارات التعلّم والمنافسة والنماذج الأولية — دون الحاجة إلى بطاقة ائتمان. خطط الفرق والمدارس قادمة قريباً.',
  },
  contactTitle: { en: 'Contact Us', ar: 'تواصل معنا' },
  lblPhone: { en: 'Phone', ar: 'رقم الهاتف' },
  lblEmail: { en: 'Email', ar: 'البريد الإلكتروني' },
  rights: { en: 'All rights reserved.', ar: 'جميع الحقوق محفوظة.' },
  comingSoon: { en: 'Coming Soon', ar: 'قريباً' },
} satisfies Record<string, Bilingual>;
